import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BoldPrefix} from '../../pipes/boldprefix.pipe';
import {SDGsModalComponent} from '../../modal/sdgs-modal/sdgs-modal.component';
import {IonicModule} from '@ionic/angular';


@NgModule({
  declarations: [
    BoldPrefix,
    SDGsModalComponent
  ],
  imports: [
    IonicModule,
    CommonModule
  ],
  exports: [
    BoldPrefix,
    SDGsModalComponent
  ]
})
export class SharedModule {
}
